import * as constants from '../constants';
import { addCalculate, getCalculate, clearCalculate } from '../../item-calculate/constants';
import {
    getCalculatorMordovia,
    clearCalculatorMordovia,
    addGroupCalculate,
    setActiveCalculate
} from '../../mordovia/constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getDistribution.success:
        case constants.addDistribution.success:
        case constants.updateDistribution.success: {
            return action.payload;
        }

        case getCalculate.success:
        case addCalculate.success: {
            const { distribution } = action.payload;
            return distribution;
        }

        case clearCalculatorMordovia.toString():
        case clearCalculate.toString():
        case constants.clearDistribution.toString(): {
            return initialState;
        }

        case getCalculatorMordovia.success: {
            const calculator = { ...action.payload?.calculator?.distribution };
            return calculator;
        }

        case addGroupCalculate.success: {
            const calculator = { ...action.payload?.calculator?.distribution };
            return calculator;
        }

        case setActiveCalculate.toString(): {
            const calculator = { ...action.payload?.distribution };
            return calculator;
        }

        default:
            return state;
    }
}
